import { render, staticRenderFns } from "./CategoryDescription.vue?vue&type=template&id=9c24e11c&"
import script from "./CategoryDescription.vue?vue&type=script&lang=js&"
export * from "./CategoryDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports